import { render, staticRenderFns } from "./QuotationDocumentAgricola.vue?vue&type=template&id=42ec6f2c&scoped=true"
import script from "./QuotationDocumentAgricola.vue?vue&type=script&lang=js"
export * from "./QuotationDocumentAgricola.vue?vue&type=script&lang=js"
import style0 from "./QuotationDocumentAgricola.vue?vue&type=style&index=0&id=42ec6f2c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ec6f2c",
  null
  
)

export default component.exports